/******************************************************************************\
 * :$
 *
 * Copyright(c) 2022 SAS Institute Inc., Cary, NC, USA. All Rights Reserved.
 *
 * Name: TimeoutDialog
 *
 * Purpose:
 *
 * Author: craig (Craig.Simpson@sas.com)
 *
 * Support: SAS(r) Solutions OnDemand
 *
 * Input:
 *
 * Output:
 *
 * Parameters: (if applicable)
 *
 * Dependencies/Assumptions:
 *
 * Usage:
 *
 * History:
 * ddmmmyyyy userid description (Change Code)
 * 08Dec2022 craig File created.
 \******************************************************************************/
import React from "react";
import {Button, Modal} from "react-bootstrap";

interface DialogProps {
    show:boolean,
    handleStayLoggedIn:any
}

export const TimeoutDialog: React.FC<DialogProps> = ({show, handleStayLoggedIn}: DialogProps) => {
    return (
        <Modal show={show} keyboard={false} backdrop={"static"} >
            <Modal.Header closeButton={false} >
                <Modal.Title>Session Timeout!</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Your session is about to expire in 5 minutes due to inactivity.
            </Modal.Body>
            <Modal.Footer>
                <Button variant={"secondary"} onClick={handleStayLoggedIn}>
                    Stay Logged In
                </Button>
            </Modal.Footer>
        </Modal>
    )
}